module.exports = __webpack_public_path__ + "static/medal-min-6cf8bc5932738bde4fae8c3c19b37ddf.png";